import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'

export interface Settings {
    weightReferredTo1dm2: boolean
}

@Injectable()
export class SettingsService {
    constructor(private http: HttpService) {
        //
    }

    public get(organizationId?: string): Observable<Settings> {
        return this.http.get<Settings>(`/settings${organizationId ? '/' + organizationId : ''}`)
    }
}
